module.exports = __webpack_public_path__ + "img/opportunity_house_white.d8ceb659.svg";